var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.997,
    height: 59.996,
    viewBox: "0 0 59.997 59.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5ab3f9;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43204",
    "data-name": "\\u7EC4 43204",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35510",
    "data-name": "\\u8DEF\\u5F84 35510",
    className: "cls-1",
    d: "M148.008,36.124a30,30,0,1,1,30,30,30,30,0,0,1-30-30",
    transform: "translate(-148.008 -6.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_2288",
    "data-name": "\\u77E9\\u5F62 2288",
    className: "cls-2",
    d: "M6.658,0H23.312A6.658,6.658,0,0,1,29.97,6.658v6.234a6.657,6.657,0,0,1-6.657,6.657H6.658A6.658,6.658,0,0,1,0,12.891V6.658A6.658,6.658,0,0,1,6.658,0Z",
    transform: "translate(15.013 25.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35511",
    "data-name": "\\u8DEF\\u5F84 35511",
    className: "cls-2",
    d: "M172.811,23.134l2.954,2.954a1.128,1.128,0,0,0,1.6,0l2.956-2.954",
    transform: "translate(-146.566 -5.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35512",
    "data-name": "\\u8DEF\\u5F84 35512",
    className: "cls-2",
    d: "M172.811,18.882l2.954,2.954a1.128,1.128,0,0,0,1.6,0l2.956-2.954",
    transform: "translate(-146.566 -5.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35513",
    "data-name": "\\u8DEF\\u5F84 35513",
    className: "cls-2",
    d: "M172.811,14.63l2.954,2.954a1.128,1.128,0,0,0,1.6,0l2.956-2.954",
    transform: "translate(-146.566 -5.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35514",
    "data-name": "\\u8DEF\\u5F84 35514",
    className: "cls-3",
    d: "M181.718,35.477a.529.529,0,1,0,.529-.528.529.529,0,0,0-.529.528",
    transform: "translate(-146.044 -4.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35515",
    "data-name": "\\u8DEF\\u5F84 35515",
    className: "cls-3",
    d: "M182.253,36.134a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.051 -4.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35516",
    "data-name": "\\u8DEF\\u5F84 35516",
    className: "cls-3",
    d: "M179.97,35.477a.529.529,0,1,0,.529-.528.529.529,0,0,0-.529.528",
    transform: "translate(-146.146 -4.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35517",
    "data-name": "\\u8DEF\\u5F84 35517",
    className: "cls-3",
    d: "M180.505,36.134a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.153 -4.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35518",
    "data-name": "\\u8DEF\\u5F84 35518",
    className: "cls-3",
    d: "M183.466,37.066a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-145.942 -4.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35519",
    "data-name": "\\u8DEF\\u5F84 35519",
    className: "cls-3",
    d: "M184,37.722a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-145.949 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35520",
    "data-name": "\\u8DEF\\u5F84 35520",
    className: "cls-3",
    d: "M181.718,37.066a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.044 -4.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35521",
    "data-name": "\\u8DEF\\u5F84 35521",
    className: "cls-3",
    d: "M182.253,37.722a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.051 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35522",
    "data-name": "\\u8DEF\\u5F84 35522",
    className: "cls-3",
    d: "M179.97,37.066a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.146 -4.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35523",
    "data-name": "\\u8DEF\\u5F84 35523",
    className: "cls-3",
    d: "M180.505,37.722a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.153 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35524",
    "data-name": "\\u8DEF\\u5F84 35524",
    className: "cls-3",
    d: "M178.222,37.066a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.248 -4.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35525",
    "data-name": "\\u8DEF\\u5F84 35525",
    className: "cls-3",
    d: "M178.757,37.722a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.254 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35526",
    "data-name": "\\u8DEF\\u5F84 35526",
    className: "cls-3",
    d: "M183.466,38.654a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-145.942 -4.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35527",
    "data-name": "\\u8DEF\\u5F84 35527",
    className: "cls-3",
    d: "M184,39.31a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-145.949 -4.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35528",
    "data-name": "\\u8DEF\\u5F84 35528",
    className: "cls-3",
    d: "M181.718,38.654a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.044 -4.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35529",
    "data-name": "\\u8DEF\\u5F84 35529",
    className: "cls-3",
    d: "M182.253,39.31a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.051 -4.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35530",
    "data-name": "\\u8DEF\\u5F84 35530",
    className: "cls-3",
    d: "M179.97,38.654a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.146 -4.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35531",
    "data-name": "\\u8DEF\\u5F84 35531",
    className: "cls-3",
    d: "M180.505,39.31a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.153 -4.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35532",
    "data-name": "\\u8DEF\\u5F84 35532",
    className: "cls-3",
    d: "M178.222,38.654a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.248 -4.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35533",
    "data-name": "\\u8DEF\\u5F84 35533",
    className: "cls-3",
    d: "M178.757,39.31a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.254 -4.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35534",
    "data-name": "\\u8DEF\\u5F84 35534",
    className: "cls-3",
    d: "M183.466,40.243a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-145.942 -4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35535",
    "data-name": "\\u8DEF\\u5F84 35535",
    className: "cls-3",
    d: "M184,40.9a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.409.408A.409.409,0,0,1,184,39.84",
    transform: "translate(-145.949 -4.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35536",
    "data-name": "\\u8DEF\\u5F84 35536",
    className: "cls-3",
    d: "M181.718,40.243a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.044 -4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35537",
    "data-name": "\\u8DEF\\u5F84 35537",
    className: "cls-3",
    d: "M182.253,40.9a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.409.408.409.409,0,0,1,.409-.408",
    transform: "translate(-146.051 -4.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35538",
    "data-name": "\\u8DEF\\u5F84 35538",
    className: "cls-3",
    d: "M179.97,40.243a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.146 -4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35539",
    "data-name": "\\u8DEF\\u5F84 35539",
    className: "cls-3",
    d: "M180.505,40.9a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.409.408.409.409,0,0,1,.409-.408",
    transform: "translate(-146.153 -4.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35540",
    "data-name": "\\u8DEF\\u5F84 35540",
    className: "cls-3",
    d: "M178.222,40.243a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.248 -4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35541",
    "data-name": "\\u8DEF\\u5F84 35541",
    className: "cls-3",
    d: "M178.757,40.9a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.409.408.409.409,0,0,1,.409-.408",
    transform: "translate(-146.254 -4.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35542",
    "data-name": "\\u8DEF\\u5F84 35542",
    className: "cls-3",
    d: "M183.466,41.831a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-145.942 -4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35543",
    "data-name": "\\u8DEF\\u5F84 35543",
    className: "cls-3",
    d: "M184,42.488a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.409.408.409.409,0,0,1,.409-.408",
    transform: "translate(-145.949 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35544",
    "data-name": "\\u8DEF\\u5F84 35544",
    className: "cls-3",
    d: "M181.718,41.831a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.044 -4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35545",
    "data-name": "\\u8DEF\\u5F84 35545",
    className: "cls-3",
    d: "M182.253,42.488a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.409.408.409.409,0,0,1,.409-.408",
    transform: "translate(-146.051 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35546",
    "data-name": "\\u8DEF\\u5F84 35546",
    className: "cls-3",
    d: "M179.97,41.831a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.146 -4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35547",
    "data-name": "\\u8DEF\\u5F84 35547",
    className: "cls-3",
    d: "M180.505,42.488a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.409.408.409.409,0,0,1,.409-.408",
    transform: "translate(-146.153 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35548",
    "data-name": "\\u8DEF\\u5F84 35548",
    className: "cls-3",
    d: "M178.222,41.831a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.248 -4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35549",
    "data-name": "\\u8DEF\\u5F84 35549",
    className: "cls-3",
    d: "M178.757,42.488a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.409.408.409.409,0,0,1,.409-.408",
    transform: "translate(-146.254 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35550",
    "data-name": "\\u8DEF\\u5F84 35550",
    className: "cls-3",
    d: "M181.718,43.42a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.044 -3.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35551",
    "data-name": "\\u8DEF\\u5F84 35551",
    className: "cls-3",
    d: "M182.253,44.076a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.051 -3.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35552",
    "data-name": "\\u8DEF\\u5F84 35552",
    className: "cls-3",
    d: "M179.97,43.42a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.146 -3.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35553",
    "data-name": "\\u8DEF\\u5F84 35553",
    className: "cls-3",
    d: "M180.505,44.076a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.409.409.409.409,0,0,1,.409-.409",
    transform: "translate(-146.153 -3.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35554",
    "data-name": "\\u8DEF\\u5F84 35554",
    className: "cls-3",
    d: "M171.74,35.477a.529.529,0,1,0,.529-.528.529.529,0,0,0-.529.528",
    transform: "translate(-146.625 -4.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35555",
    "data-name": "\\u8DEF\\u5F84 35555",
    className: "cls-3",
    d: "M172.275,36.134a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.632 -4.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35556",
    "data-name": "\\u8DEF\\u5F84 35556",
    className: "cls-3",
    d: "M169.992,35.477a.529.529,0,1,0,.529-.528.529.529,0,0,0-.529.528",
    transform: "translate(-146.727 -4.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35557",
    "data-name": "\\u8DEF\\u5F84 35557",
    className: "cls-3",
    d: "M170.527,36.134a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.734 -4.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35558",
    "data-name": "\\u8DEF\\u5F84 35558",
    className: "cls-3",
    d: "M173.488,37.066a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.523 -4.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35559",
    "data-name": "\\u8DEF\\u5F84 35559",
    className: "cls-3",
    d: "M174.023,37.722a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.53 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35560",
    "data-name": "\\u8DEF\\u5F84 35560",
    className: "cls-3",
    d: "M171.74,37.066a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.625 -4.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35561",
    "data-name": "\\u8DEF\\u5F84 35561",
    className: "cls-3",
    d: "M172.275,37.722a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.632 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35562",
    "data-name": "\\u8DEF\\u5F84 35562",
    className: "cls-3",
    d: "M169.992,37.066a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.727 -4.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35563",
    "data-name": "\\u8DEF\\u5F84 35563",
    className: "cls-3",
    d: "M170.527,37.722a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.734 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35564",
    "data-name": "\\u8DEF\\u5F84 35564",
    className: "cls-3",
    d: "M168.244,37.066a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.829 -4.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35565",
    "data-name": "\\u8DEF\\u5F84 35565",
    className: "cls-3",
    d: "M168.779,37.722a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.836 -4.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35566",
    "data-name": "\\u8DEF\\u5F84 35566",
    className: "cls-3",
    d: "M173.488,38.654a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.523 -4.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35567",
    "data-name": "\\u8DEF\\u5F84 35567",
    className: "cls-3",
    d: "M174.023,39.31a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.53 -4.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35568",
    "data-name": "\\u8DEF\\u5F84 35568",
    className: "cls-3",
    d: "M171.74,38.654a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.625 -4.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35569",
    "data-name": "\\u8DEF\\u5F84 35569",
    className: "cls-3",
    d: "M172.275,39.31a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.632 -4.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35570",
    "data-name": "\\u8DEF\\u5F84 35570",
    className: "cls-3",
    d: "M169.992,38.654a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.727 -4.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35571",
    "data-name": "\\u8DEF\\u5F84 35571",
    className: "cls-3",
    d: "M170.527,39.31a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.734 -4.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35572",
    "data-name": "\\u8DEF\\u5F84 35572",
    className: "cls-3",
    d: "M168.244,38.654a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.829 -4.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35573",
    "data-name": "\\u8DEF\\u5F84 35573",
    className: "cls-3",
    d: "M168.779,39.31a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.836 -4.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35574",
    "data-name": "\\u8DEF\\u5F84 35574",
    className: "cls-3",
    d: "M173.488,40.243a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.523 -4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35575",
    "data-name": "\\u8DEF\\u5F84 35575",
    className: "cls-3",
    d: "M174.023,40.9a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.408.408.409.409,0,0,1,.408-.408",
    transform: "translate(-146.53 -4.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35576",
    "data-name": "\\u8DEF\\u5F84 35576",
    className: "cls-3",
    d: "M171.74,40.243a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.625 -4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35577",
    "data-name": "\\u8DEF\\u5F84 35577",
    className: "cls-3",
    d: "M172.275,40.9a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.408.408.409.409,0,0,1,.408-.408",
    transform: "translate(-146.632 -4.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35578",
    "data-name": "\\u8DEF\\u5F84 35578",
    className: "cls-3",
    d: "M169.992,40.243a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.727 -4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35579",
    "data-name": "\\u8DEF\\u5F84 35579",
    className: "cls-3",
    d: "M170.527,40.9a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.408.408.409.409,0,0,1,.408-.408",
    transform: "translate(-146.734 -4.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35580",
    "data-name": "\\u8DEF\\u5F84 35580",
    className: "cls-3",
    d: "M168.244,40.243a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.829 -4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35581",
    "data-name": "\\u8DEF\\u5F84 35581",
    className: "cls-3",
    d: "M168.779,40.9a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.408.408.409.409,0,0,1,.408-.408",
    transform: "translate(-146.836 -4.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35582",
    "data-name": "\\u8DEF\\u5F84 35582",
    className: "cls-3",
    d: "M173.488,41.831a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.523 -4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35583",
    "data-name": "\\u8DEF\\u5F84 35583",
    className: "cls-3",
    d: "M174.023,42.488a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.408.408.409.409,0,0,1,.408-.408",
    transform: "translate(-146.53 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35584",
    "data-name": "\\u8DEF\\u5F84 35584",
    className: "cls-3",
    d: "M171.74,41.831a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.625 -4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35585",
    "data-name": "\\u8DEF\\u5F84 35585",
    className: "cls-3",
    d: "M172.275,42.488a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.408.408.409.409,0,0,1,.408-.408",
    transform: "translate(-146.632 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35586",
    "data-name": "\\u8DEF\\u5F84 35586",
    className: "cls-3",
    d: "M169.992,41.831a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.727 -4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35587",
    "data-name": "\\u8DEF\\u5F84 35587",
    className: "cls-3",
    d: "M170.527,42.488a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.408.408.409.409,0,0,1,.408-.408",
    transform: "translate(-146.734 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35588",
    "data-name": "\\u8DEF\\u5F84 35588",
    className: "cls-3",
    d: "M168.244,41.831a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.829 -4.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35589",
    "data-name": "\\u8DEF\\u5F84 35589",
    className: "cls-3",
    d: "M168.779,42.488a.649.649,0,1,0-.649-.65.65.65,0,0,0,.649.65m0-1.058a.408.408,0,1,1-.408.408.409.409,0,0,1,.408-.408",
    transform: "translate(-146.836 -4.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35590",
    "data-name": "\\u8DEF\\u5F84 35590",
    className: "cls-3",
    d: "M171.74,43.42a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.625 -3.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35591",
    "data-name": "\\u8DEF\\u5F84 35591",
    className: "cls-3",
    d: "M172.275,44.076a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.632 -3.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35592",
    "data-name": "\\u8DEF\\u5F84 35592",
    className: "cls-3",
    d: "M169.992,43.42a.529.529,0,1,0,.529-.529.529.529,0,0,0-.529.529",
    transform: "translate(-146.727 -3.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35593",
    "data-name": "\\u8DEF\\u5F84 35593",
    className: "cls-3",
    d: "M170.527,44.076a.649.649,0,1,0-.649-.649.65.65,0,0,0,.649.649m0-1.058a.408.408,0,1,1-.408.409.409.409,0,0,1,.408-.409",
    transform: "translate(-146.734 -3.991)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon--download.3d270e763605a9becb6995cafcab5b14.svg";
export { ForwardRef as ReactComponent };